@for (option of radioButtons(); track option; let i = $index) {
    <label class="flex items-center gap-8">
        <input
            class="border-400 block size-20 cursor-pointer appearance-none rounded-full border-2 border-solid checked:border-blue checked:bg-[radial-gradient(circle,#00aad2_48%,white_50%)]"
            [value]="option.value"
            [checked]="option.value === value()"
            [name]="inputId"
            [id]="inputId + '-' + i"
            (click)="checkedChange(option.value)"
            type="radio"
        />
        <span>{{ option.label }}</span>
    </label>
}
